module.exports = __webpack_public_path__ + "static/media/num_hub_color_logo.790d1d66.svg";